import React from 'react'
import PropTypes from 'prop-types'

import { CardContainer } from './styles'

const Card = ({
  onClick, children, className, style
}) => (
  <CardContainer style={{ ...style }} onClick={onClick} className={className}>
    {children}
  </CardContainer>
)

Card.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  style: PropTypes.shape({}),
  onClick: PropTypes.func,
  className: PropTypes.string,
}

Card.defaultProps = {
  style: null,
  onClick: null,
  className: '',
}

export default Card
